import type { AccountDetailPayload, AccountMetricView } from '../account-detail.model';
import { formatAccountBalanceExact, formatAccountDate } from '../accounts-display';

export function mapDebtSummary(payload: AccountDetailPayload): AccountMetricView[] {
  const optedOut =
    typeof payload.optedOut === 'boolean' ? (payload.optedOut ? 'Yes' : 'No') : 'n/a';
  return [
    { label: 'Balance due', value: formatAccountBalanceExact(payload.balance) },
    { label: 'Opted out', value: optedOut },
    { label: 'Advance taken', value: formatAccountDate(payload.advanceTakenDate) },
  ];
}
